import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import giftIcon from '../../../../assets/green-yellow-gift.png';
import { useStores } from '../../../../stores/useStores';
import Button from '../../../buttons/Button';
import { DialogBox } from '../../../Dialog/DialogBox';
import { DialogContent } from '../../../Dialog/DialogContent';

import styles from './DailyLimitDialog.module.scss';

const DailyLimitDialog = observer(() => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { promotionStore } = useStores();
  const { t } = useTranslation();

  const removePcQueryParam = () => {
    if (searchParams.has('pc')) {
      searchParams.delete('pc');
      setSearchParams(searchParams);
    }
  };

  const closeDialog = () => {
    removePcQueryParam();
    promotionStore.closePromotionDialog();
  };

  const onCloseClickHandler = () => {
    promotionStore.sendAnalyticsEvent({ event_action: 'click', click_location: 'close' });
    closeDialog();
  };

  const onCtaClickHandler = () => {
    promotionStore.sendAnalyticsEvent({ event_action: 'click', click_location: 'cta', button_text: 'got_it' });
    closeDialog();
  };

  return (
    <DialogBox className={styles.dailyLimitDialog}>
      <div className={styles.header}>
        <button aria-label="Close" className={styles.closeButton} type="button" onClick={onCloseClickHandler}>
          <svg
            aria-hidden="true"
            fill="none"
            height="24"
            viewBox="0 0 24 24"
            width="24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18 6L6 18M6 6L18 18"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2.5"
            />
          </svg>
        </button>
      </div>

      <DialogContent className={styles.content}>
        <h2 className={styles.title}>{t('promoCode.dailyLimit.title')}</h2>
        <p className={styles.body}>{t('promoCode.dailyLimit.body')}</p>

        <div className={styles.giftIconWrapper}>
          <img alt="Gift" className={styles.giftIcon} src={giftIcon} />
        </div>

        <p className={styles.footer}>{t('promoCode.dailyLimit.footer')}</p>

        <Button className={styles.ctaButton} onClick={onCtaClickHandler}>
          {t('promoCode.dailyLimit.cta')}
        </Button>
      </DialogContent>
    </DialogBox>
  );
});

export default DailyLimitDialog;
